import { render, staticRenderFns } from "./role-modify.vue?vue&type=template&id=c0e94e78&"
import script from "./role-modify.vue?vue&type=script&lang=js&"
export * from "./role-modify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports